import { ChatSDK } from '@tencentcloud/chat';
import { TUIChatEngine } from '@tencentcloud/chat-uikit-engine';
import {
  Chat,
  ChatHeader,
  MessageList,
  MessageInput,
  useUIOpenControlState,
  useConversationListState,
  ChatSetting,
  Search,
  VariantType,
} from '@tencentcloud/chat-uikit-react';
import { UIKitProvider } from '@tencentcloud/uikit-base-component-react';
import Mobile from '@/layout/Mobile';
import { useOutlet } from '@/context/OutletContext';
import { Drawer } from '@/components/Drawer';
import { useEffect, useRef } from 'react';

interface IChatboxProps {
  chat?: ChatSDK;
}

function Chatbox({ chat }: IChatboxProps) {
  const { env, theme, language } = useOutlet();

  const onlyOpenOnce = useRef(true);

  const {
    isChatSettingOpen,
    setChatSettingOpen,
    isChatSearchOpen,
    setChatSearchOpen,
  }  = useUIOpenControlState();

  const { setActiveConversation, conversationList } = useConversationListState();

  useEffect(() => {
    if (conversationList && conversationList.length > 0) {
      const firstGroupChat = conversationList.find((item) => item.type === TUIChatEngine.TYPES.CONV_GROUP);
      if (firstGroupChat && firstGroupChat.conversationID && onlyOpenOnce.current) {
        setActiveConversation(firstGroupChat.conversationID);
        onlyOpenOnce.current = false;
      }
    }
  }, [conversationList]);

  const ChatBoxUIKit = (
    <UIKitProvider
      chat={chat}
      theme={theme}
      language={language}
    >
      <Chat>
        <ChatHeader chatHeaderActions={['chatSetting', 'search']}/>
        <MessageList />
        <MessageInput />
        <Drawer
          open={isChatSettingOpen}
          onClose={() => setChatSettingOpen(false)}
          container={null}
          anchor="right"
          size={360}
          transitionDuration={200}
        >
          <ChatSetting style={{ minWidth: 'auto'}} />
        </Drawer>
        <Drawer
          open={isChatSearchOpen}
          onClose={() => setChatSearchOpen(false)}
          container={null}
          anchor="right"
          size={360}
        >
          <Search variant={VariantType.EMBEDDED} />
        </Drawer>
      </Chat>
    </UIKitProvider>
  );

  return env === 'web' ? ChatBoxUIKit : <Mobile>{ChatBoxUIKit}</Mobile>;
}

export default Chatbox;
